export enum ErrorCode {
  Unauthorized = 'UNAUTHORIZED',
  Forbidden = 'FORBIDDEN',
  NotFound = 'NOT_FOUND',
  ValidationError = 'VALIDATION_ERROR',
  InvalidCommand = 'INVALID_COMMAND',
  RateLimited = 'RATE_LIMITED',
  InternalError = 'INTERNAL_ERROR',
  RoomFull = 'ROOM_FULL',
  /** A guest's join, refused while nobody signed in is in the room. */
  NoSignedInMember = 'NO_SIGNED_IN_MEMBER',
  MemberNotFound = 'MEMBER_NOT_FOUND',
  InvalidHost = 'INVALID_HOST',
  RoomClosed = 'ROOM_CLOSED',
  EntryNotFound = 'ENTRY_NOT_FOUND',
  DuplicateEntry = 'DUPLICATE_ENTRY',
  PeerNotFound = 'PEER_NOT_FOUND',
  NotInRoom = 'NOT_IN_ROOM',
  NotAPerformer = 'NOT_A_PERFORMER',
  MixerNotFound = 'MIXER_NOT_FOUND',
  ChannelNotFound = 'CHANNEL_NOT_FOUND',
  DuplicateChannel = 'DUPLICATE_CHANNEL',
  TransportNotFound = 'TRANSPORT_NOT_FOUND',
  ProducerNotFound = 'PRODUCER_NOT_FOUND',
  ConsumerNotFound = 'CONSUMER_NOT_FOUND',
  TrackNotFound = 'TRACK_NOT_FOUND',
  InvalidSource = 'INVALID_SOURCE',
  LyricsNotFound = 'LYRICS_NOT_FOUND',
  InvalidLyricsFormat = 'INVALID_LYRICS_FORMAT',
}
